// <ScrollButton scrollStepInPx='50' delayInMs='16.66' />

import styled from "styled-components";
import tw from 'twin.macro'
import React from 'react'
import {animateScroll as scroll} from 'react-scroll';

function ScrollButton ({ scrollStepInPx, delayInMs }) {
  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  return (
    <BackTopButton onClick={() => scrollToTop()}>
      ↑
    </BackTopButton>
  )
}

// language=SCSS prefix=*{ suffix=}
const BackTopButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 20px;
  bottom: 70px;
  z-index:99;
  ${tw`bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow`}
  
  
  svg {
    width: 24px;
    height: 24px;
    ${tw`fill-current text-white`}
  }
`

export default ScrollButton